module.exports = __webpack_public_path__ + "static/img/1-0.d1845b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/product/1-0.png
// module id = YZPo
// module chunks = 15